import React, {Component} from "react";
import { registerReactApp, reactAppLoaded } from '../services/reactLoadTracker';
import PropTypes from "prop-types";
import * as api from "../services/api";
import TeaserList from '../components/TeaserList/TeaserList';
import PaginationControl from "../components/Filter/PaginationControl";
import translate from "../services/translation";
import TeaserItem from "../components/Favourites/TeaserItem";

export class ItineraryRecommendationApp extends Component {

    static propTypes = {
        filter: PropTypes.object,
        favouriteLink: PropTypes.string,
    }

    static initialLimit = 3;

    initialState = {
        filter: {...this.props.filter, limit: ItineraryRecommendationApp.initialLimit, offset: 0},
        itineraries: [],
        itinerariesTotal: [],
        loading: false,
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    loadMore = () => {
        const newFilter = {
            ...this.state.filter,
            limit: parseInt(this.state.filter.limit,10) + ItineraryRecommendationApp.initialLimit,
            offset: parseInt(this.state.filter.offset,10) + ItineraryRecommendationApp.initialLimit
        };

        this.setState({filter: newFilter}, () => {
            this.fetchItineraries(true);
        })
    };

    fetchItineraries = (append = false) => {
        this.setState({loading: true});

        api.getItinerariesByLtrKeys(this.state.filter).then(
            response => {
                if(append) {
                    const newItineraries = this.state.itineraries.concat(response.data);
                    this.setState({itineraries: newItineraries});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({itineraries: response.data});
                    } else {
                        this.setState({itineraries: []});
                    }
                }
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            },
            error => {
                console.error(error.message);
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            }
        )
    };

    // just here to estimate the total. not that good but BE says is to dangerous the work on the api
    fetchItinerariesTotalTotal = (append = false) => {
        this.setState({loading: true});
        api.getItinerariesByLtrKeys({...this.props.filter, limit: 100}).then(
            response => {
                if(append) {
                    const newItineraries = this.state.itinerariesTotal.concat(response.data);
                    this.setState({itinerariesTotal: newItineraries});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({itinerariesTotal: response.data});
                    } else {
                        this.setState({itinerariesTotal: []});
                    }
                }
                this.setState({loading: false});
            },
            error => {
                console.error(error.message);
                this.setState({loading: false});
            }
        )
    };

    componentDidMount() {
        registerReactApp();
        this.fetchItinerariesTotalTotal();
        this.fetchItineraries();
    }

    render() {
        const {itineraries, loading, itinerariesTotal} = this.state;

        return (
            <div className="itineraryRecommendations">
                <h3>{translate('itinerary_travel_recommendations_title')}</h3>
                <div className="itineraryRecommendationsList">
                    {
                        itineraries.length !== 0 ? <TeaserList teasers={itineraries} favouriteLink={this.props.favouriteLink} /> : ''
                    }
                </div>

                {itineraries.length === 0 && !loading &&
                    <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div>
                }

                {itinerariesTotal.length > 3 && itineraries.length === parseInt(this.state.filter.limit,10) ?
                    <PaginationControl paginate={this.loadMore} /> : ''
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/apps/ItineraryRecommendationApp.js